/**
 * Template AIMM Scripts
 * Version: 1.0.0
 * Description: Main JavaScript file for Template AIMM
 * Author: Microsite Team
 * Last Updated: 2025-10-29
 */

// import external dependencies
import 'jquery';

// Import everything from autoload
import '../../autoload/_bootstrap.js';

import Router from '../../util/Router';
import pageTemplate from './page';

/** Populate Router instance with DOM routes */
const routes = new Router({
  pageTemplate,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());




// WEBPACK FOOTER //
// ./scripts/page-template/template-aimm/main.js